import {
  NavbarContainer,
  Logo,
  SearchContainer,
  AddButton,
  Bar,
  MobileIcon,
  BackIcon,
  ProfileIcon,
} from "./navbar.styles";
import { IconsContainer, Icon } from "../dashboardComponents/dashboard.styles";
import DropdownMenu from "../dropdown/dropdown.component";
import Search from "../search/search.component";
import BellIcon from "../../assets/icons/bell.svg";
import LanguageChanger from "../languageChanger/languageChanger.component";
import { useState, useEffect, useContext } from "react";
import AddIcon from "../../assets/icons/add.svg";
import SearchIcon from "../../assets/icons/blackSearch.svg";
import BlackAdd from "../../assets/icons/blackAdd.svg";
import { UserContext } from "../../contexts/user.context";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import ToogleServerModel from "../modals/toggleServerModel/ToogleServerModel.component";
import { Get } from "../../utils/fetch.util";
import ChangePasswordModel from "../modals/changePasswordModel/ChangePasswordModel";
import UpdateCompanyModel from "../modals/updateCompanyModel/UpdateCompanyModel.component";
import AddAsdcAdminModel from "../modals/AddAsdcAdminModel/AddAsdcAdminModel.component";
import { useCommanData } from "../../contexts/commanData.context";
import { LuRecycle } from "react-icons/lu";
import packageJson from "../../../package.json";

type NavbarProps = {
  toggleModal?: () => void;
  search?: (searchTerm: string) => void;
  services?: boolean;
};

const Navbar = ({ toggleModal, search, services }: NavbarProps) => {
  const { signOut, user, getValidToken } = useContext(UserContext);
  const [searchValue, setSearchValue] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [statusServer, setStatusServer] = useState<boolean>(false);
  const [openServerModel, setOpenServerModel] = useState<boolean>(false);
  const [openChangePassword, setOpenChangePassword] = useState<boolean>(false);
  const [openUpdateCompany, setOpenUpdateCompany] = useState<boolean>(false);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    if (search) {
      search(searchValue);
    }
  }, [searchValue]);

  const getStatusServer = async (): Promise<boolean | undefined> => {
    const res = await Get(
      `asdc-client/check-server-under-maintenance`,
      getValidToken()
    );
    if (res.error || !res.data) return;
    setStatusServer(res.data);
  };

  // useEffect(() => {
  //   getStatusServer();
  // }, []);

  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  return (
    <>
      <NavbarContainer>
        <Link to={"/admin/dashboard"} className="flex items-center">
          <Logo />
        </Link>
        {search && (
          <SearchContainer show={showSearch}>
            {showSearch && (
              <MobileIcon onClick={toggleSearch}>
                <BackIcon />
              </MobileIcon>
            )}
            <Search
              value={searchValue}
              onChange={handleChange}
              show={showSearch}
            />
            <AddButton onClick={toggleModal}>
              <Icon src={AddIcon} />
            </AddButton>
          </SearchContainer>
        )}

        {services && (
          <button
            onClick={toggleModal}
            className="bg-[#64A7C4] text-white p-5 py-3 rounded-md"
          >
            {t("contract__add_service")}
          </button>
        )}
        <IconsContainer>
          {search && (
            <>
              <MobileIcon>
                <Icon src={BlackAdd} onClick={toggleModal} />
              </MobileIcon>
              <MobileIcon onClick={toggleSearch}>
                <Icon src={SearchIcon} />
              </MobileIcon>
            </>
          )}

          {/* <Icon src={BellIcon} /> */}

          <LanguageChanger />

          <DropdownMenu
            items={[
              {
                label: t("adminDashboard__apps"),
                clickHandler: () => {
                  navigate("/admin/apps");
                },
              },
              {
                label: t("services"),
                clickHandler: () => {
                  navigate("/admin/services");
                },
              },
              {
                label: t("subscriptions"),
                clickHandler: () => {
                  navigate("/admin/subscriptions");
                },
              },
              // {
              //   label: t("app_version"),
              //   clickHandler: () => {
              //     navigate("/admin/app-version");
              //   },
              // },
              // {
              //   label: t(
              //     statusServer ? "make_server_go_down" : "make_server_go_up"
              //   ),
              //   clickHandler: () => {
              //     setOpenServerModel(true);
              //   },
              // },
              {
                label: t("admins"),
                clickHandler: () => {
                  navigate("/admin/admins");
                },
              },
              {
                label: t("countries"),
                clickHandler: () => {
                  navigate("/admin/countries");
                },
              },
              {
                label: t("holidays"),
                clickHandler: () => {
                  navigate("/admin/holidays");
                },
              },
              // {
              //   label: t("bug_tickets"),
              //   clickHandler: () => {
              //     navigate("/admin/bug-tickets/under-reviewing");
              //   },
              // },
              // {
              //   label: t("update_company"),
              //   clickHandler: () => {
              //     setOpenUpdateCompany(true);
              //   },
              // },
              {
                label: t("change_password"),
                clickHandler: () => {
                  setOpenChangePassword(true);
                },
              },
              // {
              //   label: "edit dashboard",
              //   clickHandler: () => {
              //     window.location.href = "https://editor.rasid.com.eg";
              //   },
              // },
              // {
              //   label: t("prosper_dashboard"),
              //   clickHandler: () => {
              //     window.location.href = `https://prosper.rasid.com.eg/redirect?token=${getValidToken()}`;
              //   },
              // },
              { label: t("signout"), clickHandler: signOut },
            ]}
          >
            <ProfileIcon>
              {/* {this next statment is to get the first to letters of the user name} */}
              {user
                ? `${user[0]?.asdc_admin_user_name
                    ?.split(" ")[0][0]
                    ?.toUpperCase()}${
                    user[0]?.asdc_admin_user_name
                      ?.split(" ")?.[1]?.[0]
                      ?.toUpperCase() ||
                    user[0]?.asdc_admin_user_name
                      ?.split(" ")[0][1]
                      ?.toUpperCase()
                  }`
                : "AD"}
            </ProfileIcon>
          </DropdownMenu>
        </IconsContainer>
      </NavbarContainer>
      <ToogleServerModel
        setOpen={setOpenServerModel}
        open={openServerModel}
        statusServer={statusServer}
        setStatusServer={setStatusServer}
      />
      <ChangePasswordModel
        open={openChangePassword}
        setOpen={setOpenChangePassword}
      />
      <UpdateCompanyModel
        setOpen={setOpenUpdateCompany}
        open={openUpdateCompany}
      />

      <Bar />
    </>
  );
};
export default Navbar;
